<template>
  <v-card :loading="loading">
    <v-card-title>WiFi</v-card-title>
    <v-card-text>
      <p>If hosting at an off-site location, enter N/A</p>
      <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
        <v-form>
          <ValidationProvider name="network" rules="required"  v-slot="{ errors, valid }">
            <v-text-field
              label="Network"
              v-model="assignment_data.wifi_name"
              :error-messages="errors"
              :success="valid"></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="password" rules="required"  v-slot="{ errors, valid }">
            <v-text-field
              label="Password"
              v-model="assignment_data.wifi_password"
              :error-messages="errors"
              :success="valid"></v-text-field>
          </ValidationProvider>
          <v-btn color="primary" class="mr-4" @click="submit()" :disabled="invalid">submit</v-btn>
        </v-form>
      </ValidationObserver>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'

export default {
  props: {
    assignment_data: Object,
    loading: Boolean
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    submit() {
      this.$emit('updateinfo')
    }
  }
}
</script>